import { connect } from 'react-redux';
import { TSubscribeStatus } from '@cian/reviews-subscribe-component';

import { IReviewsSubscribeDispatchProps, IReviewsSubscribeProps, ReviewsSubscribe } from '.';
import { IAppState, TUser } from '../../store';
import {
  onSubscribe,
  onUnsubscribe,
  setEmailError,
  setSubscribeStatus,
  subscribeChangeEmail,
  subscribeClosePopup,
  subscribeOpenPopup,
} from '../../store/subscribe_reviews';
import { TThunkDispatch } from '../../types/redux';

function getEmail(subscribeEmail: string | undefined, user: TUser): string {
  if (typeof subscribeEmail === 'undefined' && user.isAuthenticated) {
    return user.email || '';
  }

  return subscribeEmail || '';
}

function mapStateToProps(state: IAppState): IReviewsSubscribeProps {
  return {
    email:
      state.reviews.isUserSubscribed && state.reviews.subscriptionEmail
        ? state.reviews.subscriptionEmail || ''
        : getEmail(state.subscribeReviews.subscribeEmail, state.user),
    emailError: state.subscribeReviews.emailError,
    isFetching: state.subscribeReviews.isFetching,
    isOpenSubscribeReviewsPopup: state.subscribeReviews.isOpenSubscribeReviewsPopup,
    isUserAuthenticated: state.user.isAuthenticated,
    subscribeStatus: state.subscribeReviews.subscribeStatus
      ? state.subscribeReviews.subscribeStatus
      : state.reviews.isUserSubscribed
      ? 'subscribe'
      : 'noSubscribe',
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): IReviewsSubscribeDispatchProps {
  return {
    onSubscribe: (email: string) => dispatch(onSubscribe(email)),
    onUnsubscribe: (email: string) => dispatch(onUnsubscribe(email)),
    setEmailError: (emailError: string) => dispatch(setEmailError(emailError)),
    setSubscribeStatus: (subscribeStatus: TSubscribeStatus) => dispatch(setSubscribeStatus(subscribeStatus)),
    subscribeChangeEmail: (email: string | undefined) => dispatch(subscribeChangeEmail(email)),
    subscribeClosePopup: () => dispatch(subscribeClosePopup()),
    subscribeOpenPopup: () => dispatch(subscribeOpenPopup()),
  };
}

export const ReviewsSubscribeContainer = connect<IReviewsSubscribeProps, IReviewsSubscribeDispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewsSubscribe);
